module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Eraser-1683f77f9237ec46fad46a6fe2ec164d.svg";